// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'share';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.313 3.938h-6.188a2.25 2.25 0 0 0-2.25 2.25V9' />
    <path d='m12.938 7.313 3.374-3.375L12.938.562m1.125 10.126v5.624a1.125 1.125 0 0 1-1.126 1.125H2.813a1.125 1.125 0 0 1-1.126-1.125v-9a1.125 1.125 0 0 1 1.125-1.125H4.5' />
  </g>
);

export const viewBox = '0 0 18 18';
